import { createStyles, makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import objectFitImages from 'object-fit-images';
import * as React from 'react';
import { useState } from 'react';

const rotate = {
    '0%': {
        '-webkit-transform-origin': 'center',
        transformOrigin: 'center',
        '-webkit-transform': `translate3d(-50%,-50%,0) rotate(0)`,
        transform: `translate3d(-50%,-50%,0) rotate3d(0, 0, 1, 0)`,
    },
    '100%': {
        '-webkit-transform-origin': 'center',
        transformOrigin: 'center',
        '-webkit-transform': `translate3d(-50%,-50%,0) rotate(360deg)`,
        transform: `translate3d(-50%,-50%,0) rotate3d(0, 0, 1, 360deg)`,
    }
};

export type ImageProps =
    React.HTMLAttributes<HTMLElement> & {
        pictureRef?: PictureRef;
        imageSrc?: string;
        sizes?: string;
        srcSet?: string;
        minWidth?: number;
        maxWidth?: number;
        steps?: number;
        alt?: string;
        // includeRatio?: boolean;
        onLoad?: () => void;
        onError?: () => void;
    };

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            position: 'relative',
            width: '100%',
            height: '100%',
            zIndex: 0,
        },
        imageContainer: {
            position: 'relative',
            width: '100%',
            height: '100%',
            zIndex: 0,
            opacity: 0,
            transition: 'opacity 400ms ease-in-out',

            '$loaded &': {
                opacity: 1,
            },
        },
        loading: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
            pointerEvents: 'none',
            opacity: 1,
            // transition: 'opacity .5s ease',
            background: 'rgba(0,0,0,0.03)',
            transition: 'opacity 400ms ease-in-out, background 400ms ease-in-out',

            '$loaded &': {
                opacity: 0,
                background: 'rgba(0,0,0,0.0)',
            }
        },
        loaded: {},
        element: {
            position: 'absolute',
            top: "50%",
            left: "50%",
            transition: 'transform linear 0.2s',
            borderRadius: "50%",
            border: '1px solid rgba(0,0,0,.7)',
            borderTopColor: 'transparent',
            background: 'transparent',
            width: "1.2rem",
            height: "1.2rem",
            display: 'block',
            transform: 'translate3d(-50%,-50%,0)',
            animationName: '$rotate',
            animationIterationCount: 'infinite',
            animationDuration: '1s',
            animationTimingFunction: 'linear',
        },
        '@keyframes rotate': rotate
    }));

export const Image: React.FC<ImageProps> = (props) => {

    const classes = useStyles();

    React.useEffect(
        () => {
            objectFitImages();
        },
        []
    );

    const { alt, className, children } = props;
    const [loading, setLoading] = useState(true);

    const maxWidth = props.maxWidth || 4000;
    const minWidth = props.minWidth || 200;
    let steps = (props.steps || 10);
    const stepSize = (maxWidth - minWidth) / steps;
    const sizes = props.sizes || '100vw';
    const width = props.pictureRef && props.pictureRef.Width || 0;
    const imageSrc = props.pictureRef && props.pictureRef.Src || props.imageSrc || '';

    const srcSet: string[] = [];
    steps++;

    while (steps--) {
        const w = stepSize * steps + minWidth;
        if (width && w > width) { continue; }
        const src = `${imageSrc}?width=${w} ${w}w`;
        srcSet.push(src);
    }

    // push imgSrc at real size
    srcSet.push(`${imageSrc}?width=${width} ${width}w`);

    const atts: React.ImgHTMLAttributes<HTMLImageElement> = {
        alt,
        className,
        srcSet: srcSet.join(', ') || '',
        sizes,
        src: `${imageSrc}`
    };

    atts.onLoad = () => setLoading(false);

    if (props.onError) {
        atts.onError = props.onError;
    }

    return (
        <figure className={classNames(classes.root, !loading && classes.loaded)}>
            <div className={classes.loading} >
                <div className={classes.element} />
            </div>
            <div className={classes.imageContainer}>
                <img
                    {...atts}
                />
            </div>
            {children}
        </figure>
    );
}

export default Image;


// WEBPACK FOOTER //
// ./src/Components/Image.tsx